// extracted by mini-css-extract-plugin
export var banner = "_q6-0";
export var settingRow = "_q6-2";
export var titleIcon = "_q6-1";